import { takeLatest, takeEvery, call, select, take, put, fork } from 'redux-saga/effects'

import { fetchEntity } from 'Redux/rootSaga'
import { api } from 'Redux/services'

import * as R from 'ramda'
import { getToken, getUserID } from 'Modules/user/data/selectors'
import { FILTER_META } from 'Modules/searchFilters/actions'
import { initTagManager } from 'Modules/searchFilters/sagas'
import { selectMeta } from 'Modules/searchFilters/selectors'
import { SUCCESS, FAILURE } from 'Redux/actions/constants'
import { parseSearchQueryWithBaseUrl } from 'Utils/routerUtils'
import { areaParamList } from 'Defaults/map'
import { paramsToTags, getTag } from 'Utils/searchFilterUtils'
import errorLogger from 'Root/errorLogger'

import { NOTIFICATION_SUCCESS, NOTIFICATION_ERROR } from 'Modules/notifications/actions'
import {
  getUserSearches,
  API_UPDATE_USER_SEARCH,
  LOAD_ALERT_LISTINGS,
  fetchAlertListingsActions,
  USER_SEARCHES,
  updateAlertTagsApiActions,
  UPDATE_ALERT_TAGS_API,
  UPDATE_ALERT_REBUILD_TAGS,
  updateAlertRebuildTags,
  API_DELETE_USER_SEARCH,
} from './actions'

import {
  selectSavedAlerts,
  selectListingAlerts,
} from './selectors'


function* handleUpdateAlertSuccess(action) {
  const onSuccess = action.request.onSuccess
  yield put({ type: NOTIFICATION_SUCCESS, msg: 'Listing Alert Updated' })
  if(onSuccess) onSuccess()
}

const apiListings = payload => api.callApi('map-search/listings-list', {
  mode: 'GET',
  data: {
    ...payload,
  },
})
function* handleLoadAlertListings(action) {
  const { query, alertId, requireMeta, perPage } = action
  const payload = parseSearchQueryWithBaseUrl(query)
  let meta = yield select(selectMeta)

  if(!meta && requireMeta) {
    yield take(FILTER_META[SUCCESS])
    meta = yield select(selectMeta)
  }
  payload.per_page = perPage
  try {
    yield put(fetchAlertListingsActions.request({ alertId }))
    const res = yield apiListings(payload)
    // match with algolia response
    yield put(fetchAlertListingsActions.success(null, {
      res: {
        hits: res.response.data.data,
        nbHits: res.response.data.total,
      },
      alertId,
    }))
  } catch(e) {
    yield put(fetchAlertListingsActions.failure({ alertId }))
    const userId = yield select(getUserID)
    errorLogger('handleLoadAlertListings', e + ' uId: ' + userId)
  }
  // if(true) {
  //
  // } else {
  //   if(payload.mode && !payload.offer) {
  //     payload.offer = payload.mode
  //   }
  //   payload = parsePayloadForShape(payload)
  //   payload.attributesToRetrieve = ['photo_base_url', 'photo_count', 'mls_number', 'photo_version']
  //   try {
  //     yield put(fetchAlertListingsActions.request({ alertId }))
  //     const res = yield call(algoliaInstance.handleSearch, { payload, meta })
  //     yield put(fetchAlertListingsActions.success(null, { res, alertId }))
  //   } catch(e) {
  //     yield put(fetchAlertListingsActions.failure({ alertId }))
  //     const userId = yield select(getUserID)
  //     errorLogger('handleLoadAlertListings', e + ' uId: ' + userId)
  //   }
  // }
}


const apiReComputeAlertTags = (
  {
    payload,
    token,
  }) => api.callApi('users/alerts/tags', {
  mode: 'PATCH',
  contentType: 'application/json',
  token,
  data: payload,
})
const fetchReComputeAlertTags = (payload) => fetchEntity(updateAlertTagsApiActions, apiReComputeAlertTags, payload)

function* handleRecomputeTags(action) {
  const res = action.response.data
  if(res.status === 1) {
    const data = res.data
    const requireRecomputeTags = []
    const areas = {}
    if(!data.listing_alerts) return null
    data.listing_alerts.forEach(alert => {
      if(alert.rebuild_tags && alert.url) {
        const paramObj = parseSearchQueryWithBaseUrl(alert.url) || {}

        requireRecomputeTags.push({
          ...alert,
          lastSearchObj: paramObj,
        })
        areaParamList.forEach(areaKey => {
          if(paramObj[areaKey]) {
            if(areas[areaKey]) areas[areaKey] += ',' + paramObj[areaKey]
            else areas[areaKey] = paramObj[areaKey]
          }
        })
      }
    })
    // if all valid do not update
    if(!requireRecomputeTags || !requireRecomputeTags.length) return null

    // fetch areas with algolia
    const areaNameLookup = yield call(initTagManager, { params: areas })

    let meta = yield select(selectMeta)
    if(!meta) {
      yield take(FILTER_META[SUCCESS])
      meta = yield select(selectMeta)
    }

    const updateAlertsObj = {}
    if((R.isEmpty(areas) || areaNameLookup) && meta) {
      // extract tags from param obj
      requireRecomputeTags.forEach(invAlert => {
        const tags = paramsToTags({
          lastSearchObj: invAlert.lastSearchObj,
          selectedItems: {},
          metaLookup: meta,
          tagLookups: areaNameLookup,
        }).map(getTag)
        if(tags) {
          try {
            updateAlertsObj[invAlert.id] = JSON.stringify(tags)
          } catch(e) {
            errorLogger('filterInvalidListingAlert json stringify', e)
          }
        }
      })
      const token = yield select(getToken)
      yield fork(fetchReComputeAlertTags, { payload: { updated_list: updateAlertsObj }, token })
      yield take(UPDATE_ALERT_TAGS_API[SUCCESS], { updateAlertsObj })
      yield put(updateAlertRebuildTags({ updateAlertsObj }))
    }
  }
}
// after successfully send rebuild tags to back
// update tags in store
function* onRebuildTagsSuccessHandler(action) {
  const listingAlerts = yield select(selectListingAlerts)
  if(!action.updateAlertsObj) return null
  const withTagsAlerts = listingAlerts.map(alert => {
    const tags = action.updateAlertsObj[alert.id]
    if(tags) {
      return {
        ...alert,
        tags,
        rebuild_tags: false,
      }
    }
    return alert
  })
  const list = yield select(selectSavedAlerts)

  const payload = {
    data: {
      data: {
        ...list,
        listing_alerts: withTagsAlerts,
      },
    },
  }
  yield put(getUserSearches.success(null, payload))
}

function* onAlertDelete(action) {
  if(action.error) {
    yield put({ type: NOTIFICATION_ERROR, msg: action.error.body.message })
  }
}

export function* watchLoadSavedSearchListings() {
  yield takeLatest(USER_SEARCHES[SUCCESS], handleRecomputeTags)
  yield takeLatest(API_UPDATE_USER_SEARCH[SUCCESS], handleUpdateAlertSuccess)
  yield takeLatest(API_DELETE_USER_SEARCH[FAILURE], onAlertDelete)
  yield takeLatest(UPDATE_ALERT_REBUILD_TAGS, onRebuildTagsSuccessHandler)
  yield takeEvery(LOAD_ALERT_LISTINGS, handleLoadAlertListings)
}
